/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BoardSlugIndexRouteImport } from './routes/$boardSlug/index'
import { Route as BoardSlugThreadThreadIdRouteImport } from './routes/$boardSlug/thread.$threadId'
import { Route as BoardSlugSpaceThreadIdRouteImport } from './routes/$boardSlug/space.$threadId'
import { Route as BoardSlugGalleryThreadIdRouteImport } from './routes/$boardSlug/gallery.$threadId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardSlugIndexRoute = BoardSlugIndexRouteImport.update({
  id: '/$boardSlug/',
  path: '/$boardSlug/',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardSlugThreadThreadIdRoute = BoardSlugThreadThreadIdRouteImport.update({
  id: '/$boardSlug/thread/$threadId',
  path: '/$boardSlug/thread/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardSlugSpaceThreadIdRoute = BoardSlugSpaceThreadIdRouteImport.update({
  id: '/$boardSlug/space/$threadId',
  path: '/$boardSlug/space/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardSlugGalleryThreadIdRoute =
  BoardSlugGalleryThreadIdRouteImport.update({
    id: '/$boardSlug/gallery/$threadId',
    path: '/$boardSlug/gallery/$threadId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/settings': typeof SettingsRoute
  '/$boardSlug/': typeof BoardSlugIndexRoute
  '/$boardSlug/gallery/$threadId': typeof BoardSlugGalleryThreadIdRoute
  '/$boardSlug/space/$threadId': typeof BoardSlugSpaceThreadIdRoute
  '/$boardSlug/thread/$threadId': typeof BoardSlugThreadThreadIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/settings': typeof SettingsRoute
  '/$boardSlug': typeof BoardSlugIndexRoute
  '/$boardSlug/gallery/$threadId': typeof BoardSlugGalleryThreadIdRoute
  '/$boardSlug/space/$threadId': typeof BoardSlugSpaceThreadIdRoute
  '/$boardSlug/thread/$threadId': typeof BoardSlugThreadThreadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/settings': typeof SettingsRoute
  '/$boardSlug/': typeof BoardSlugIndexRoute
  '/$boardSlug/gallery/$threadId': typeof BoardSlugGalleryThreadIdRoute
  '/$boardSlug/space/$threadId': typeof BoardSlugSpaceThreadIdRoute
  '/$boardSlug/thread/$threadId': typeof BoardSlugThreadThreadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/settings'
    | '/$boardSlug/'
    | '/$boardSlug/gallery/$threadId'
    | '/$boardSlug/space/$threadId'
    | '/$boardSlug/thread/$threadId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/settings'
    | '/$boardSlug'
    | '/$boardSlug/gallery/$threadId'
    | '/$boardSlug/space/$threadId'
    | '/$boardSlug/thread/$threadId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/settings'
    | '/$boardSlug/'
    | '/$boardSlug/gallery/$threadId'
    | '/$boardSlug/space/$threadId'
    | '/$boardSlug/thread/$threadId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  SettingsRoute: typeof SettingsRoute
  BoardSlugIndexRoute: typeof BoardSlugIndexRoute
  BoardSlugGalleryThreadIdRoute: typeof BoardSlugGalleryThreadIdRoute
  BoardSlugSpaceThreadIdRoute: typeof BoardSlugSpaceThreadIdRoute
  BoardSlugThreadThreadIdRoute: typeof BoardSlugThreadThreadIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$boardSlug/': {
      id: '/$boardSlug/'
      path: '/$boardSlug'
      fullPath: '/$boardSlug/'
      preLoaderRoute: typeof BoardSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$boardSlug/thread/$threadId': {
      id: '/$boardSlug/thread/$threadId'
      path: '/$boardSlug/thread/$threadId'
      fullPath: '/$boardSlug/thread/$threadId'
      preLoaderRoute: typeof BoardSlugThreadThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$boardSlug/space/$threadId': {
      id: '/$boardSlug/space/$threadId'
      path: '/$boardSlug/space/$threadId'
      fullPath: '/$boardSlug/space/$threadId'
      preLoaderRoute: typeof BoardSlugSpaceThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$boardSlug/gallery/$threadId': {
      id: '/$boardSlug/gallery/$threadId'
      path: '/$boardSlug/gallery/$threadId'
      fullPath: '/$boardSlug/gallery/$threadId'
      preLoaderRoute: typeof BoardSlugGalleryThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  SettingsRoute: SettingsRoute,
  BoardSlugIndexRoute: BoardSlugIndexRoute,
  BoardSlugGalleryThreadIdRoute: BoardSlugGalleryThreadIdRoute,
  BoardSlugSpaceThreadIdRoute: BoardSlugSpaceThreadIdRoute,
  BoardSlugThreadThreadIdRoute: BoardSlugThreadThreadIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
